import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { SquaredTickIcon } from "../../ui/icons/SquaredTickIcon"
import { formatterDate, NotificationExpirationTypeOptions, NotificationReleaseStatusOptions, NotificationTypeOptions, NotificationVariationOptions, optionsFormatter } from "../../utils"
import { useEffect } from "react"
import { GetAllNotification, setNotificationIdToUpdate } from "./slice"
import { setNotificationStatusFiltersNotificationId } from "./biologica/stato/slice"
import { NotificationDTO } from "./dataservice/dto"

export function NotifyListBio() {
    const dispatch = useAppDispatch()
    const notificationState = useAppSelector(state => state.notification)
    const sessionState = useAppSelector(state => state.session)
    const navigate = useNavigate()

    const onEditHandle = (n: NotificationDTO) => {
        dispatch(setNotificationIdToUpdate(n.id))
        navigate('/notifyBioEdit')
    }

    useEffect(() => {
        dispatch(GetAllNotification({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
    }, [])

    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. Documento</th>
                        <th className="width-[130px]">Attività</th>
                        <th className="width-[100px]">Data Rilascio</th>
                        <th className="width-[130px]">Stato</th>
                        <th className="width-[20%]">Caso</th>
                        <th className="width-[130px]">Protocollo CDX</th>
                        <th className="width-[130px]">Tipo</th>
                        <th className="width-[130px]">Variazione</th>
                        <th className="width-[130px]">OdC Precedente</th>
                        <th className="width-[130px]">Fonte/Regione</th>
                        <th className="width-[130px]">Conforme</th>
                        <th className="width-[130px]">Superata</th>
                        <th className="width-[130px]">Certificato</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        notificationState.getAllNotificationResponse?.data.map((notify, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button onClick={() => onEditHandle(notify)}>
                                            <SquaredTickIcon />
                                        </button>
                                    </div>
                                </td>
                                <td>{notify.identifier}</td>
                                <td>{notify.activity}</td>
                                <td>{formatterDate(notify.releaseDate)}</td>
                                <td>{optionsFormatter(notify.releaseStatus, NotificationReleaseStatusOptions)}</td>
                                <td>{optionsFormatter(notify.expirationType, NotificationExpirationTypeOptions)}</td>
                                <td>{notify.notificationProtocolInfo}</td>
                                <td>{optionsFormatter(notify.type, NotificationTypeOptions)}</td>
                                <td>{optionsFormatter(notify.variation, NotificationVariationOptions)}</td>
                                <td>{notify.previousOdc}</td>
                                <td>{notify.regionSource}</td>
                                <td>{notify.notificationValidation ? 'Sì' : 'No'}</td>
                                <td>{notify.certifiedSubsequentNotificationIssued ? 'Sì' : 'No'}</td>
                                <td>{'notify.certificate'}</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>
    )
}